import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2, Home } from 'lucide-react'
import { useAppDispatch } from '../../../../../store/hooks'
import { setActiveTab } from '../../../../../store/slices/tabsSlice'

interface ProcessingModalProps {
  isProcessing: boolean
  hasAnnotations: boolean
  progress: number
  progressMessage: string
}

export const ProcessingModal: React.FC<ProcessingModalProps> = ({
  isProcessing,
  hasAnnotations,
  progress,
  progressMessage
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  if (!isProcessing || hasAnnotations) {
    return null
  }

  return (
    <div className="absolute inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-auto p-6 sm:p-8">
        <div className="text-center">
          {/* Processing Icon */}
          <div className="mb-4 sm:mb-6">
            <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-orange-100 rounded-full">
              <Loader2 className="w-6 h-6 sm:w-8 sm:h-8 text-orange-500 animate-spin" />
            </div>
          </div>
          
          {/* Title */}
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
            Processing Document
          </h3>
          
          {/* Progress */}
          <div className="mb-3 sm:mb-4">
            <div className="flex justify-between text-xs sm:text-sm text-gray-600 mb-2">
              <span className="truncate mr-2">{progressMessage}</span>
              <span className="font-medium flex-shrink-0">{progress}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-orange-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
          
          {/* Message */}
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
            The AI system is processing this document. You can track progress in the Activity bar on the right. 
            Comprehensive extraction and analysis will take a few minutes. Meanwhile, you can return to the home tab or click here to start a new extraction.
          </p>
          
          {/* Action Button */}
          <button
            onClick={() => {
              dispatch(setActiveTab('home'))
              navigate('/app')
            }}
            className="w-full flex items-center justify-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors text-sm sm:text-base"
          >
            <Home className="w-4 h-4 sm:w-5 sm:h-5" />
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}

